import { executeQuery } from 'common/gql';
import type {
  UpdateBirthdateMutation,
  UpdateBirthdateMutationVariables,
  UpdateSubscriptionsMutation,
  UpdateSubscriptionsMutationVariables,
} from 'common/gql/generated/schema';
import updateBirthdateMutation from 'common/gql/mutation/user/update-birthdate.gql';
import updateSubscriptionsMutation from 'common/gql/mutation/user/updateSubscriptions.gql';

export const performUpdateBirthdate = (variables: UpdateBirthdateMutationVariables) =>
  executeQuery<UpdateBirthdateMutation, UpdateBirthdateMutationVariables>({
    variables,
    query: updateBirthdateMutation,
    useApq: true,
  });

export const performSubscribeHomeClubNewsletter = (
  variables: UpdateSubscriptionsMutationVariables
) =>
  executeQuery<UpdateSubscriptionsMutation, UpdateSubscriptionsMutationVariables>({
    variables,
    query: updateSubscriptionsMutation,
  });
